import type { ReactNode } from 'react'

import Link from 'next/link'
import { trackEvent } from '@/lib/analytics/client'
import { DIRECTORY_INDEX_PATH } from '@/lib/seo/telegram-directory'

/**
 * Where a visitor entered the Telegram directory from. Recorded as
 * `metadata.source` on a `telegram_directory_entry_click`, so the placements can
 * be compared without a second analytics system.
 */
export type DirectoryEntrySource = 'homepage' | 'marketplace_nav' | 'footer' | 'for_communities'

interface DirectoryEntryLinkProps {
    source: DirectoryEntrySource
    className?: string
    children: ReactNode
    onNavigate?: () => void
}

/**
 * THE ONE LINK INTO THE DIRECTORY from the rest of Bazio. A plain, crawlable
 * Next.js link to `/telegram-groups` (no nofollow, no JavaScript-only routing);
 * the click beacon is fire-and-forget and never delays navigation.
 */
export const DirectoryEntryLink = ({ source, className, children, onNavigate }: DirectoryEntryLinkProps): ReactNode => (
    <Link
        href={DIRECTORY_INDEX_PATH}
        className={className}
        onClick={() => {
            trackEvent({ type: 'telegram_directory_entry_click', metadata: { source } })
            onNavigate?.()
        }}
    >
        {children}
    </Link>
)

export default DirectoryEntryLink
